import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { RouteError } from '@/components/shared/route-error'

export function DefaultErrorComponent({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])
  return <RouteError error={error} reset={reset} />
}
